import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { getDictionaryGroups } from './index';
import { isNotNullOrUndefined } from '../../../util/types/Array';

export const getAllGroupsWithChainGroups = createSelector(
  [getDictionaryGroups],
  (dictionaryGroups) =>
    Object.values(dictionaryGroups ?? {}).map((group) => {
      return {
        ...group,
        chainGroups: group?.pathGroupsIds
          .map((groupId) => dictionaryGroups?.[groupId])
          .filter(isNotNullOrUndefined),
      };
    })
);
